const mailValidator = (mail: string | null, canBeEmpty = false) => {
  if (
    canBeEmpty &&
    (mail === null || mail === undefined || mail.trim() === "")
  ) {
    return "";
  }
  if (!mail) {
    return "error.email.empty";
  }
  if (mail.length > 69) {
    return "error.sageName.maxLength69";
  }
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!re.test(mail)) {
    return "error.email.valid";
  }
  return "";
};
export default mailValidator;
